import React, { Fragment } from "react";
import { List, Datagrid, Edit, Create, SimpleForm, TextField, SearchInput, EditButton, TextInput, BooleanField, TranslatableFields, BooleanInput, CreateButton, TopToolbar, useRecordContext } from 'react-admin';
import CategoryIcon from '@material-ui/icons/Category';
import OrderingField from '../Fields/Ordering.field';
import { Route, useHistory } from 'react-router';
import { Drawer, makeStyles } from '@material-ui/core';
import { required } from 'react-admin';
import { translations } from '../../i18n/i18n';
import ConfigGeneral from '../../config/general';

const useStyles = makeStyles({
	drawerContent: {
		width: 500
	},
	iconContainer: {
		'&& svg': {
			height: 30,
		},
	},
});

const filters = [
    <SearchInput source="translations.name" alwaysOn />,
];

const ListActions = ({ basePath }) => (
	<TopToolbar>
		<CreateButton basePath={basePath} />
	</TopToolbar>
);

const IconField = (props) => {
	const classes = useStyles();
    const { source } = props;
    const record = useRecordContext(props);
    return <div className={classes.iconContainer} dangerouslySetInnerHTML={{__html: record[source]}}></div>;
}

const PlaceTypeIcon = CategoryIcon;
const PlaceTypeList = (props) => {
	const classes = useStyles();
	const history = useHistory();
	const handleClose = () => history.push('/'+props.resource);

	return <Fragment>
		<List actions={<ListActions />} filters={filters} perPage={25} sort={{ field: 'ordering', order: 'ASC' }} {...props}>
			<Datagrid>
				<TextField source="id" />
				<IconField source="icon" />
				<TextField source="name_display" sortable={false} />
				<BooleanField source="state" looseValue />
				<OrderingField source="ordering" />
				<EditButton basePath="/placetypes" />
			</Datagrid>
		</List>

		<Route path={'/'+props.resource+'/create'} exact>
			{({ match }) => (
				<Drawer open={!!match} anchor="right" onClose={handleClose}>
					<PlaceTypeCreate className={classes.drawerContent} onCancel={handleClose} {...props} />
				</Drawer>
			)}
		</Route>

		<Route path={'/'+props.resource+'/:id'}>
			{({ match }) => {
				const isMatch = (match && match.params && match.params.id !== 'create');

				return (
					<Drawer open={!!isMatch} anchor="right" onClose={handleClose}>
						{isMatch ? (
							<PlaceTypeEdit
								className={classes.drawerContent}
								id={isMatch ? match.params.id : null}
								onCancel={handleClose}
								{...props}
							/>
						) : (
							<div className={classes.drawerContent} />
						)}
					</Drawer>
				);
			}}
		</Route>
	</Fragment>
};

const PlaceTypeEdit = (props) => (
    <Edit title=" " undoable={false} {...props}>
        <SimpleForm>
			<TranslatableFields locales={ConfigGeneral.locales.map(locale => locale.code)}>
				<TextInput source="name" fullWidth validate={[required()]} />
			</TranslatableFields>
			<TextInput multiline source="icon" fullWidth validate={[required()]} />
            <BooleanInput source="state" />
        </SimpleForm>
    </Edit>
);

const PlaceTypeCreate = (props) => (
    <Create title=" " undoable={false} {...props}>
        <SimpleForm>
			<TranslatableFields locales={ConfigGeneral.locales.map(locale => locale.code)}>
				<TextInput source="name" fullWidth validate={[required()]} />
			</TranslatableFields>
			<TextInput multiline source="icon" fullWidth validate={[required()]} />
            <BooleanInput source="state" />
        </SimpleForm>
    </Create>
);

let exports = {
	list: PlaceTypeList,
	icon: PlaceTypeIcon,
};
export default exports;